<template>
  <v-container pa-2>
    <v-card class="mt-2 pb-0" style="border-radius: 5px">
      <!-- Toolbar -->
      <v-toolbar
        dense
        color="#ECCD20"
        flat
        style="color: #000; text-align: center; font-size: 140%"
      >
        <v-spacer></v-spacer>SELEZIONA LA TUA COLLEZIONE
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container>
        <v-layout :class="[this.$i2kFunctions.isSmartphone() ? 'column' : 'row']">
          <v-spacer></v-spacer>
          <div>
            <img
              :src="img_speedy"
              width="100%"
              @click="openPreve('speedy')"
              style="cursor: pointer"
            />
          </div>
          <v-spacer></v-spacer>
          <div>
            <img
              :src="img_porte"
              width="100%"
              @click="openPreve('porte')"
              @mouseover="img_porte = img_porte2"
              @mouseout="img_porte = img_porte3"
              style="cursor: pointer"
            />
          </div>
          <v-spacer></v-spacer>
        </v-layout>

        <v-layout :class="[this.$i2kFunctions.isSmartphone() ? 'column' : 'row']">
          <v-spacer></v-spacer>
          <div>
            <img
              :src="img_arredo"
              width="100%"
              @click="openPreve('arredo')"
              @mouseover="img_arredo = img_arredo2"
              @mouseout="img_arredo = img_arredo3"
              style="cursor: pointer"
            />
          </div>
          <v-spacer></v-spacer>
          <div>
            <img
              :src="img_sicur"
              width="100%"
              @click="openPreve('sicur')"
              @mouseover="img_sicur = img_sicur2"
              @mouseout="img_sicur = img_sicur3"
              style="cursor: pointer"
            />
          </div>
          <v-spacer></v-spacer>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>


<script>
import img_speedy from "@/assets/img/prev_speedy.png";

import img_porte from "@/assets/img/prev_porte.png";
import img_porte2 from "@/assets/img/prev_porte_disabled.png";

import img_arredo from "@/assets/img/prev_arredo.png";
import img_arredo2 from "@/assets/img/prev_arredo_disabled.png";

import img_sicur from "@/assets/img/prev_sicur.png";
import img_sicur2 from "@/assets/img/prev_sicur_disabled.png";

export default {
  data() {
    return {
      img_speedy: img_speedy,

      img_porte: img_porte,
      img_porte2: img_porte2,
      img_porte3: img_porte, //mi serve per far tornare l'immagine normale quando il mouse si sposta

      img_arredo: img_arredo,
      img_arredo2: img_arredo2,
      img_arredo3: img_arredo, //mi serve per far tornare l'immagine normale quando il mouse si sposta

      img_sicur: img_sicur,
      img_sicur2: img_sicur2,
      img_sicur3: img_sicur, //mi serve per far tornare l'immagine normale quando il mouse si sposta
    };
  },
  methods: {
    openPreve(tipo) {
      if (tipo != "speedy") return;

      this.$router.push({
        path: "preventivi",
      });
    },

    getImg(img) {
      return this.$load.getUrlImg() + "/preventivi/" + img;
    },
  },
};
</script>